"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useBreadcrumb = exports.BreadcrumbProvider = exports.BreadcrumbContext = void 0;
var tslib_1 = require("tslib");
var jsx_runtime_1 = require("react/jsx-runtime");
var React = tslib_1.__importStar(require("react"));
var BreadcrumbContext = React.createContext(null);
exports.BreadcrumbContext = BreadcrumbContext;
function BreadcrumbProvider(_a) {
    var children = _a.children, separator = _a.separator;
    var value = React.useMemo(function () { return ({ separator: separator }); }, [separator]);
    return (0, jsx_runtime_1.jsx)(BreadcrumbContext.Provider, tslib_1.__assign({ value: value }, { children: children }));
}
exports.BreadcrumbProvider = BreadcrumbProvider;
function useBreadcrumb() {
    var ctx = React.useContext(BreadcrumbContext);
    if (!ctx) {
        throw new Error('You must provide a `BreadcrumbProvider` in order to use `useBreadcrumb`');
    }
    return ctx;
}
exports.useBreadcrumb = useBreadcrumb;
